<script setup lang="ts">
import WrApiDev from "~/components/atoms/icons/WrApiDev.vue";
import WrAppDev from "~/components/atoms/icons/WrAppDev.vue";
import WrBadge from "~/components/atoms/icons/WrBadge.vue";
import WrCalender from "~/components/atoms/icons/WrCalender.vue";
import WrClock from "~/components/atoms/icons/WrClock.vue";
import WrCmsDev from "~/components/atoms/icons/WrCmsDev.vue";
import WrEcommerce from "~/components/atoms/icons/WrEcommerce.vue";
import WrMicroService from "~/components/atoms/icons/WrMicroService.vue";
import WrMobileAppDev from "~/components/atoms/icons/WrMobileAppDev.vue";
import WrMVPDev from "~/components/atoms/icons/WrMVPDev.vue";
import WrProductEng from "~/components/atoms/icons/WrProductEng.vue";
import WrStarShield from "~/components/atoms/icons/WrStarShield.vue";
import WrTeam from "~/components/atoms/icons/WrTeam.vue";
import WrVueJs from "~/components/atoms/icons/WrVueJs.vue";
import WrAnimatedTraining from "~/components/atoms/WrAnimatedTraining.vue";
import { useGlobalStore } from "~/stores/globalStore";
const globalStore = useGlobalStore();
const colorMode = useColorMode();

const imageSrc = ref("/images/agile.webp");

onMounted(() => {
  imageSrc.value =
    colorMode.preference == "dark"
      ? "/images/agile-dark.webp"
      : "/images/agile.webp";
});
useHead({
  htmlAttrs: {
    lang: "en",
  },
  title: "Nuxt Web Development Services Company/Agency",
  meta: [
    {
      name: "description",
      content:
        "Best Nuxt web design company in India. WebReinvent is one of the leading Nuxt development company in Delhi India.",
    },
  ],
  link: [
    {
      rel: "preload",
      as: "image",
      href: "/images/agile-dark.webp",
      media: "(prefers-color-scheme: dark)",
    },
    {
      rel: "preload",
      as: "image",
      href: "/images/agile.webp",
      media: "(prefers-color-scheme: light)",
    },
  ],
});

const { isMobile, isDesktop } = useDevice();

const tabs = ref([
  { title: "Build A Software Product", active: true },
  { title: "Hire Nuxt.js Developer", active: false },
  { title: "Staff Augmentation", active: false },
]);

const handleTabClick = (index: any) => {
  tabs.value = tabs.value.map((tab, i) => ({
    ...tab,
    active: i === index,
  }));
  selectedTab.value = tabs.value.map((tab) => tab.active);

  console.log(selectedTab.value);
};

const selectedTab = ref<any>([]);
const formRef = ref();

const WrVaahCms = defineAsyncComponent(
  () => import("~/components/atoms/icons/WrVaahCms.vue")
);
const WrVaahSaas = defineAsyncComponent(
  () => import("~/components/atoms/icons/WrVaahSaas.vue")
);
const WrVaahFlutter = defineAsyncComponent(
  () => import("~/components/atoms/icons/WrVaahFlutter.vue")
);
const WrVaahNuxt = defineAsyncComponent(
  () => import("~/components/atoms/icons/WrVaahNuxt.vue")
);

const solution = ref([
  {
    title: "VaahCMS",
    svg: markRaw(WrVaahCms),
    description:
      "VaahCMS is a web application development platform built with Laravel 10, Vue 3 with structured (HMVC) Modules & Themes.",
    link: "https://vaah.dev/cms",
  },
  {
    title: "VaahSaaS",
    svg: markRaw(WrVaahSaas),
    description:
      "VaahSaaS is a module for multi-tenancy, multi-database SaaS product development for VaahCMS.",
    link: "https://vaah.dev/saas",
  },
  {
    title: "VaahFlutter",
    svg: markRaw(WrVaahFlutter),
    description:
      "Flutter scaffolding with essential and common functionalities to kick start the mobile app development.",
    link: "https://vaah.dev/flutter",
  },
  {
    title: "VaahNuxt",
    svg: markRaw(WrVaahNuxt),
    description:
      "Build frontend Nuxt 3 and VaahCMS API. Shipped with Nuxt 3, FlowBite, Tailwind CSS and Pinia.",
    link: "https://vaah.dev/nuxt",
  },
]);

const content = ref([
  {
    svg: markRaw(WrProductEng),
    title: "Reliable team <br /> of Developers",
    description: "More than 30+ Nuxt.js <br /> Certified Developers",
    link: "/services/development-services/product-engineering",
  },
  {
    svg: markRaw(WrVueJs),
    title: "Flexible and <br /> Scalable Code",
    description: "We follow industry standard coding guidelines.",
    link: "#",
  },
  {
    svg: markRaw(WrEcommerce),
    title: "Automated Code <br /> Deployment",
    description: "New releases are auto deployed using CI/CD.",
    link: "#",
  },
  {
    svg: markRaw(WrCmsDev),
    title: "Google PageSpeed Faster <br /> (> 90)",
    description: "We guarantee 3 sec page load time or less",
    link: "#",
  },
  {
    svg: markRaw(WrAppDev),
    title: "Google and<br /> Core Vitals",
    description: "For Better Website Performance",
    link: "#",
  },
  {
    svg: markRaw(WrMobileAppDev),
    title: "Can handle<br /> heavy traffic",
    description: "None of our developers will have production credentials",
    link: "#",
  },
  {
    svg: markRaw(WrApiDev),
    title: "Automated <br /> Testing",
    description:
      "Each release will be test <br /> using automated test scripts.",
    link: "#",
  },
  {
    svg: markRaw(WrMVPDev),
    title: "SEO <br /> Friendly",
    description: "Boosting your website's SEO with effective strategies",
    link: "#",
  },
  {
    svg: markRaw(WrAppDev),
    title: "HIPAA-Compliant <br /> Software",
    description: "Only few companies can build HIPAA-Compliant Softwares",
    link: "#",
  },
  {
    svg: markRaw(WrMobileAppDev),
    title: "Global Ultra <br /> Low Latency",
    description:
      "Yes, we do all of that. We're very detailed and process oriented",
    link: "#",
  },
  {
    svg: markRaw(WrApiDev),
    title: "Free Software <br /> Training Video",
    description:
      "We teach you how to effective use the software and all the features",
    link: "#",
  },
  {
    svg: markRaw(WrMVPDev),
    title: "Live Training <br /> Sessions",
    description:
      "We’ll always be there to help you to address your queries live",
    link: "#",
  },
]);

const augmentation = ref([
  {
    title: "Product Engineering",
    description:
      "We offer end-to-end enterprise product development & integration.",
  },
  {
    title: "Vue Js Development",
    description: "Turn your ideas into competitive business solutions.",
  },
  {
    title: "eCommerce Development",
    description: "We create custom eCommerce applications for exceptional UX.",
  },
  {
    title: "CMS Development",
    description: "Offers secure, flexible, and efficient CMS.",
  },
]);

const devInfo = ref([
  {
    img: "/images/dev-1.webp",
    name: "Vikram Chand",
    exp: "10+ Years of experience in",
    tech: [
      "logos:laravel",
      "logos:nuxt-icon",
      "logos:vue",
      "vscode-icons:file-type-flutter",
      "material-icon-theme:react",
    ],
  },
  {
    img: "/images/dev-2.webp",
    name: "Rahul Dev",
    exp: "8+ Years of experience in",
    tech: [
      "logos:laravel",
      "logos:nuxt-icon",
      "logos:vue",
      "vscode-icons:file-type-flutter",
      "material-icon-theme:react",
    ],
  },
  {
    img: "/images/dev-3.webp",
    name: "Deep Kumar",
    exp: "7+ Years of experience in",
    tech: [
      "logos:laravel",
      "logos:nuxt-icon",
      "logos:vue",
      "vscode-icons:file-type-flutter",
      "material-icon-theme:react",
    ],
  },
  {
    img: "/images/dev-4.webp",
    name: "Himanshu Rai",
    exp: "5+ Years of experience in",
    tech: [
      "logos:laravel",
      "logos:nuxt-icon",
      "logos:vue",
      "vscode-icons:file-type-flutter",
      "material-icon-theme:react",
    ],
  },
  {
    img: "/images/devs.webp",
    name: "+25 More",
    exp: "",
    tech: [
      "logos:laravel",
      "logos:nuxt-icon",
      "logos:vue",
      "vscode-icons:file-type-flutter",
      "material-icon-theme:react",
    ],
  },
]);

const staffAchivements = ref([
  { count: "100+", title: "Trained IT Professional" },
  { count: "40+", title: "Nuxt.js Developer" },
  { count: "60+", title: "Frontend, UI/UX, DevOps, Testers" },
  { count: "10+", title: "Agencies hired from us" },
]);

const staffSpecs = ref([
  {
    svg: markRaw(WrBadge),
    title: "Senior Nuxt.js Certified Developer",
  },
  {
    svg: markRaw(WrTeam),
    title: "Scale your team in matter of days",
  },
  {
    svg: markRaw(WrCmsDev),
    title: "Indepth knowledge of Nuxt.js Ecosystem",
  },
  {
    svg: markRaw(WrMicroService),
    title: "Build monolithic or micro services architecture",
  },
]);

const oldVersion = ref([
  {
    title: "Nuxt 2",
    version: "",
    background: "bg-[#48169E]",
  },
]);

const newVersion = ref([
  {
    title: "Nuxt 3",
    version: "",
    background: "bg-[#FF2D20]",
  },
]);

const projects = ref([
  {
    id: "01",
    title: "Real time",
    tech: "PHP, Laravel, Vue, Tailwind",
  },
  {
    id: "02",
    title: "Order Management",
    tech: "PHP, Laravel, Vue, Tailwind",
  },
  {
    id: "03",
    title: "Analytic",
    tech: "PHP, Laravel, Vue, Tailwind",
  },
  {
    id: "04",
    title: "Leaning Management System",
    tech: "PHP, Laravel, Vue, Tailwind",
  },
  {
    id: "05",
    title: "Live Streaming",
    tech: "PHP, Laravel, Vue, Tailwind",
  },
]);

const outsource = ref([
  {
    id: "01",
    text: "Cost Effective Development <br> $25 (India) vs $80 (USA)",
  },
  {
    id: "02",
    text: "Most people in India are <br> comfortable in speaking English",
  },
  {
    id: "03",
    text: "Strong work ethic and dedication <br> to delivering high-quality work",
  },
  {
    id: "04",
    text: "Highly Skilled and hard working developers <br> familiar, with the latest technologies",
  },
]);

const categories = ref([
  {
    description:
      "After careful research, we chose WebReinvent Technologies. They delivered outstanding value with dedication and care throughout the project.",
    authName: "Zack Rinkins",
    authRole: "CEO",
    authImg: "/images/zack.webp",
  },
  {
    description:
      "After careful research, we chose WebReinvent Technologies. They delivered outstanding value with dedication and care throughout the project.",
    authName: "Zack Rinkins",
    authRole: "CEO",
    authImg: "/images/ankur.webp",
  },
  {
    description:
      "After careful research, we chose WebReinvent Technologies. They delivered outstanding value with dedication and care throughout the project.",
    authName: "Zack Rinkins",
    authRole: "CEO",
    authImg: "/images/taffain.webp",
  },
  {
    description:
      "After careful research, we chose WebReinvent Technologies. They delivered outstanding value with dedication and care throughout the project.",
    authName: "Zack Rinkins",
    authRole: "CEO",
    authImg: "/images/zack.webp",
  },
  {
    description:
      "After careful research, we chose WebReinvent Technologies. They delivered outstanding value with dedication and care throughout the project.",
    authName: "Zack Rinkins",
    authRole: "CEO",
    authImg: "/images/taffain.webp",
  },
  {
    description:
      "After careful research, we chose WebReinvent Technologies. They delivered outstanding value with dedication and care throughout the project.",
    authName: "Zack Rinkins",
    authRole: "CEO",
    authImg: "/images/ankur.webp",
  },
]);

// Responsive settings for the carousel
const responsiveOptions = ref([
  { breakpoint: "1400px", numVisible: 3, numScroll: 1 }, // For extra-large screens
  { breakpoint: "1200px", numVisible: 3, numScroll: 1 }, // For large screens
  { breakpoint: "992px", numVisible: 3, numScroll: 1 }, // For medium screens
  { breakpoint: "768px", numVisible: 2, numScroll: 1 }, // For smaller tablets
  { breakpoint: "576px", numVisible: 1, numScroll: 1 }, // For mobile screens
]);

const formData = ref({
  selectedUpgradeFrom: null,
  selecetedUpgradeTo: null,
  businessEmail: null,
});

const submitForm = () => {
  openModal([formData.value]);
};

const preVer = ref([{ label: "Nuxt 2" }]);

const latestVer = ref([{ label: "Nuxt 3" }]);

const items = [
  "All",
  "Pricing & Value",
  "Experience & Expertise",
  "Collaboration & Communication",
  "Company Information",
];
const activeIndex = ref(0);

const setActive = (index: any) => {
  activeIndex.value = index;
};

const accordionContent = ref([
  {
    title:
      "What makes Nuxt.JS a good choice when compared with other front-end frameworks?",
    description:
      "Nuxt.js is a modern, progressive framework that makes it easy to create powerful web applications with a single-page and fast to build, which makes it fantastic for SEO. It's the fastest framework available and is powerful enough to offer outstanding UI and UX in SPAs.",
    tags: ["All", "Company Information", "Experience & Expertise"],
  },
  {
    title:
      "Do you have an existing app and want to upgrade or fix it in Nuxt JS?",
    description:
      "With us, you can share the codebase of your current application and we'll fix all bugs, improve performance, add new features you need to work more efficiently.",
    tags: ["All", "Experience & Expertise", "Collaboration & Communication"],
  },
  {
    title:
      "If I hire dedicated Nuxt JS developers for my project, will they work for me exclusively?",
    description:
      "We avoid conflicts by ensuring that our employees never work on two projects at the same time. That means that if you choose a dedicated team model, your project will be the expert's only focus and they won't have to worry about burning out or switching to another project which may delay your deadline.",
    tags: ["All", "Collaboration & Communication", "Company Information"],
  },
  {
    title:
      "Will you continue to provide support after Nuxt.js web app development is completed?",
    description:
      "Every project we finish comes with complete support and consultation service. But this doesn't last forever. If you need any help after the fixed period, we offer affordable plans as well.",
    tags: ["All", "Collaboration & Communication", "Pricing & Value"],
  },
  {
    title:
      "What means of communication are available to us if we need to get in touch with hired developers?",
    description:
      "WebReinvent provides several communication modes for you to coordinate with your hired vue developers: Skype, Teams, Email, Meet and Zoom.",
    tags: ["All", "Collaboration & Communication", "Company Information"],
  },
  {
    title: "How much does it cost to build an application in Nuxt.js?",
    description:
      "The cost of creating a next.js website or application is obviously dependent on its complexity. From a simple personal website, to something like a business site with multiple pages and any number of elements, there are various factors which influence the cost.",
    tags: ["All", "Pricing & Value", "Company Information"],
  },
]);
const filteredAccordionContent = computed(() => {
  const selectedTag = items[activeIndex.value];
  return accordionContent.value.filter((item) =>
    item.tags.includes(selectedTag)
  );
});

const pricingContent = ref([
  {
    planTypeIcon: markRaw(WrClock),
    planLabel: "Hire on",
    billingType: "HOURLY BASIS",
    priceAmount: "$25",
    featuresList: [
      "On-Demand Model",
      "Flexibility and Scalability",
      "Focus on Core Activities",
      "Dedicated Professionals",
    ],
    ctaText: "Get started",
    highlightNote: "• Limited time offer •",
  },
  {
    planTypeIcon: markRaw(WrStarShield),
    planLabel: "Hire on",
    billingType: "MONTHLY BASIS",
    priceAmount: "$3500",
    featuresList: [
      "On-Demand Model",
      "Flexibility and Scalability",
      "Focus on Core Activities",
      "Dedicated Professionals",
    ],
    ctaText: "Get started",
    highlightNote: "• Limited time offer •",
  },
  {
    planTypeIcon: markRaw(WrCalender),
    planLabel: "Hire a",
    billingType: "SCRUM TEAM",
    priceAmount: "$15000",
    featuresList: [
      "On-Demand Model",
      "Flexibility and Scalability",
      "Focus on Core Activities",
      "Dedicated Professionals",
    ],
    ctaText: "Get started",
    highlightNote: "• Limited time offer •",
  },
]);
const visible = ref(false);
const formPrefilledData = ref(null);

const openModal = (prefilledValue = null) => {
  if (prefilledValue == null) formPrefilledData.value = null;
  else if (prefilledValue.length) formPrefilledData.value = prefilledValue;
  visible.value = true;
};
const handleButtonClick = () => {
  openModal();
};

// const preVer = ref(["Laravel 5", "Laravel 5.1", "Laravel 5.2", "Laravel 5.3", "Laravel 5.4", "Laravel 5.5", "Laravel 5.6", "Laravel 5.7", "Laravel 5.8", "Laravel 6", "Laravel 7", "Laravel 8"]);
// const latestVer = ref(["Laravel 9", "Laravel 10", "Laravel 11"]);
</script>

<template>
  <div
    class="z-10 relative dark:bg-[linear-gradient(109.63deg,#0C0226_3.67%,#1C0035_83.91%)]"
  >
    <section
      class="relative z-10 py-10 lg:py-32 overflow-visible grid place-items-center"
    >
      <div class="max-w-screen-xl mx-auto px-4 w-full relative">
        <div
          class="size-[1200px] rounded-full bg-[image:var(--bg-circle-light)] absolute -top-[115%] -left-[40%] dark:shadow-[49px_11px_53.1px_15px_#130230]"
        ></div>
        <div
          class="size-[428px] opacity-60 bg-[#AE45AA80] rounded-full absolute top-[70%] -translate-y-1/2 -left-[30%] blur-[300px]"
        ></div>
        <div
          class="size-[428px] opacity-60 bg-[image:var(--bg-circle-hero-sm)] rounded-full absolute bottom-0 -right-[30%]"
        ></div>

        <div class="z-10 relative">
          <h2 class="text-center mb-8 lg:mb-16 text-3xl lg:text-[78px]">
            <WrGradientText
              text="Official Nuxt.js partner"
              append-class="max-lg:py-0 lg:pb-10"
            />
            <span class="">enterprise solutions built to scale.</span>
          </h2>
          <p
            class="text-base md:text-xl text-center max-w-3xl px-2 mx-auto mb-20 tracking-[0.5px]"
          >
            If you're looking for a team of Nuxt.js experts to build an API, an
            application, provide consultation or code audits, we've got you
            covered.
          </p>

          <picture>
            <source :srcset="imageSrc" type="image/webp" />
            <img
              :src="imageSrc"
              alt="Agile development banner"
              class="block mx-auto"
              width="777"
              height="458"
              fetchpriority="high"
            />
          </picture>
        </div>
      </div>
    </section>

    <section
      class="relative z-10 pb-10 lg:pb-24 overflow-hidden grid place-items-center"
    >
      <div class="max-w-screen-xl mx-auto px-4 w-full">
        <h2 class="text-center mb-16">
          <WrGradientText
            text="Create powerful SaaS solutions with Nuxt.js"
            append-class="pb-4"
          />
          <p class="text-lg max-w-4xl mx-auto tracking-[0.5px] lg:px-4">
            Use VaahCLI to accelerate your workflow with quick installations,
            scaffolding modules, themes, CRUD, migrations, models, views, and
            more—all with simple commands.
          </p>
        </h2>

        <div
          class="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-7 *:w-full *:h-full"
        >
          <div
            v-for="(product, index) in solution"
            :key="index"
            class="gradient-border-mask relative p-px dark:before:bg-[linear-gradient(91.95deg,_rgba(61,27,96,0.5)_4.5%,_rgba(63,22,104,0.5)_96.91%)] before:bg-[linear-gradient(91.95deg,_rgba(182,164,199,0.5)_4.5%,_rgba(148,103,192,0.5)_96.91%)]"
          >
            <Card
              unstyled
              class="p-4 md:p-7 relative dark:bg-none bg-[var(--color-5)] dark:bg-transparent text-[var(--primary)] text-sm h-full rounded-xl"
            >
              <template #title>
                <component
                  :is="product.svg"
                  class="mb-4 text-[var(--foreground)]"
                />
              </template>
              <template #content>
                <p class="m-0">{{ product.description }}</p>
                <NuxtLink
                  :to="product.link"
                  target="_blank"
                  class="absolute z-10 block size-full inset-0"
                  :aria-label="`View details for ${product.title}`"
                />
              </template>
            </Card>
          </div>
        </div>
        <WrButton @click="handleButtonClick" container-class="mx-auto mt-6"
          >Schedule a Demo</WrButton
        >
      </div>
    </section>
    <div
      class="flex gap-8 text-sm md:text-lg font-normal max-w-max mx-auto mb-14 px-4"
    >
      <button
        v-for="(tab, index) in tabs"
        :key="tab.title"
        :aria-selected="tab.active"
        :class="
          tab.active
            ? 'max-sm:text-sm text-[var(--primary)] dark:text-white font-semibold border-b-4 !pb-3 !p-0 selected_tab after:aria-selected:top-[100%]'
            : 'text-[#838385] dark:text-[#6950AA] cursor-pointer'
        "
        @click="handleTabClick(index)"
      >
        {{ tab.title }}
      </button>
    </div>
    <div class="flex flex-col">
      <!-- Section 1: Build with Laravel Partner -->
      <section
        class="relative z-10 pb-10 lg:pb-24 overflow-hidden grid place-items-center"
        :class="selectedTab[0] ? 'order-1' : 'order-2'"
        id="`panel-0`"
        role="tabpanel"
        :aria-labelledby="`tab-0`"
      >
        <div class="max-w-screen-xl mx-auto px-10 w-full">
          <h2 class="text-center mb-16">
            <WrGradientText
              text="Build with Nuxt.js Partner"
              append-class="pb-4"
            />
            <p class="text-lg max-w-3xl mx-auto tracking-[0.5px]">
              Save time and reduce costs with a certified Nuxt.js Partner
              Company. Jumpstart development using our open-source tools like
              VaahSaaS, VaahStore, and more.
            </p>
          </h2>
          <div class="relative">
            <div
              class="grid max-sm:max-w-[350px] mx-auto max-sm:place-content-left sm:grid-cols-2 lg:grid-cols-4 relative"
            >
              <!-- <div
                                class="max-sm:hidden flex justify-between pointer-events-none absolute top-0 w-full h-full">
                                <div v-for="i in 5"
                                    class="h-full w-px even:bg-[linear-gradient(180deg,rgba(255,255,255,0.12)_-0.89%,#E1B8FF_100%)] bg-[linear-gradient(0deg,rgba(255,255,255,0.12)_-0.89%,#E1B8FF_100%)] dark:bg-[linear-gradient(180deg,rgba(255,255,255,0.12)_-0.89%,rgba(255,255,255,0)_100%)] dark:even:bg-[linear-gradient(0deg,rgba(255,255,255,0.12)_-0.89%,rgba(255,255,255,0)_100%)] max-lg:even:hidden ">
                                </div>
                            </div> -->

              <LazyWrTailored :content="content" variant="secondary" />
            </div>

            <WrButton
              @click="handleButtonClick"
              container-class="mx-auto mt-6 z-10 relative"
              >Connect with us</WrButton
            >
          </div>
        </div>
      </section>

      <section
        class="relative z-10 pb-20 lg:pb-32 grid place-items-center order-3"
      >
        <div class="max-w-screen-xl mx-auto px-4 w-full">
          <div
            class="size-[428px] opacity-60 bg-[#AE45AA80] rounded-full absolute top-[50%] left-1/2 -translate-x-1/2 blur-[300px]"
          ></div>
          <h2 class="text-center">
            <WrGradientText
              text="Multi-Tenancy Made Simple"
              append-class="py-0 lg:pb-4"
            />
            <p class="text-3xl lg:text-[48px]">
              Scale Thousands of Databases Effortlessly
            </p>
          </h2>
          <p
            class="mt-6 text-lg max-w-4xl mx-auto text-center tracking-[0.5px]"
          >
            Use the API to deploy database multi-tenant architectures. Scale to
            fleets of thousands of databases without touching a server. Rest
            easy knowing scale to zero keeps costs low.
          </p>
          <NuxtImg
            src="/images/agile.webp"
            alt="agile"
            width="777"
            height="458"
            class="mx-auto mt-12"
            loading="lazy"
            format="webp"
          />

          <WrOfficialPartners
            append-class="mt-8 md:mt-16"
            :title="'Official Partner Of'"
            :partnersAppendClass="'justify-center items-center'"
          />
        </div>
      </section>

      <!-- Section 2: Hire Certified Laravel Professionals -->
      <section
        class="relative z-10 pb-10 lg:pb-24 grid place-items-center"
        :class="selectedTab[1] ? 'order-1' : 'order-4'"
        id="`panel-1`"
        role="tabpanel"
        :aria-labelledby="`tab-1`"
      >
        <div class="max-w-screen-xl mx-auto px-4 w-full">
          <div
            class="size-[598px] bg-[#AE45AA]/10 rounded-full absolute top-[20%] left-0 -translate-x-1/2 blur-[80px]"
          ></div>
          <h2 class="text-center">
            <WrGradientText
              text="Hire Certified Nuxt.js Professionals"
              append-class="py-0 lg:py-4"
            />
            <p class="text-3xl lg:text-[48px]">For Scalable Solutions</p>
          </h2>
          <p
            class="mt-6 text-lg max-w-3xl mx-auto text-center tracking-[0.5px]"
          >
            Our Developers Are Mastered in Nuxt.js Through Comprehensive
            Training
          </p>
          <ClientOnly>
            <WrAnimatedTraining :content="'nuxt'" />
          </ClientOnly>
        </div>
        <div class="overflow-x-auto w-full px-4 no-scrollbar">
          <div class="flex gap-6 mt-16 mx-auto max-w-max">
            <WrDeveloper :dev-info="devInfo" />
          </div>
        </div>
        <WrButton container-class="mx-auto mt-12" @click="handleButtonClick"
          >Interview a Developer</WrButton
        >
      </section>

      <!-- Section 3: IT Staff Augmentation -->
      <section
        class="relative z-10 pb-20 lg:pb-36 overflow-hidden grid place-items-center"
        :class="selectedTab[2] ? 'order-1' : 'order-5'"
        id="`panel-2`"
        role="tabpanel"
        :aria-labelledby="`tab-2`"
      >
        <div class="max-w-screen-xl mx-auto px-4 w-full">
          <h2 class="text-center mb-0 lg:mb-11">
            <WrGradientText
              text="IT Staff Augmentation"
              append-class="text-5xl lg:text-[120px] bg-[image:var(--text-secondary-gradient)]"
            />
          </h2>
          <div class="flex flex-col lg:flex-row gap-10 justify-between">
            <div class="mt-4 max-lg:text-center">
              <p class="text-3xl md:text-[3rem] md:min-w-max leading-tight">
                Your Partner in <br class="max-md:hidden" />
                Workforce Growth
              </p>
              <p class="text-medium md:mt-3 tracking-[0.5px]">
                Optimize Costs and Streamline Workforce
              </p>
            </div>
            <div class="grid grid-cols-2 md:grid-cols-4 gap-4 text-white">
              <div
                v-for="item in staffAchivements"
                class="bg-[image:var(--border-staff-card)] rounded-xl p-px h-full text-white"
              >
                <div
                  class="py-6 px-4 rounded-xl text-center bg-[image:var(--bg-staff-card)] h-full"
                >
                  <p class="font-semibold text-5xl mdtext-6xl mb-2">
                    {{ item.count }}
                  </p>
                  <p class="text-medium md:text-lg line-clamp-3">
                    {{ item.title }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="grid sm:grid-cols-2 lg:grid-cols-4 my-12 gap-y-4">
            <div
              v-for="item in staffSpecs"
              class="flex gap-7 px-7 py-5 border-l border-[var(--color-10)] relative after:content-[''] after:absolute after:top-6 after:-left-px after:w-px after:h-4 after:bg-[var(--color-11)]"
            >
              <component
                :is="item.svg"
                class="shrink-0 text-[#7758AE] dark:text-[var(--foreground)]"
              />
              <p
                class="text-sm text-[var(--foreground)] dark:text-[var(--primary)] tracking-[0.5px]"
              >
                {{ item.title }}
              </p>
            </div>
          </div>

          <WrFromAugmentation @formSubmitted="openModal" />
        </div>
      </section>

      <section
        class="relative pb-10 lg:pb-24 overflow-visible grid place-items-center order-6"
      >
        <div
          v-if="$colorMode.preference == 'dark'"
          class="absolute w-[2266px] h-[1241px] top-20 rounded-[100%] bg-[linear-gradient(0deg,_#1F013405_31.11%,_#4D27B600_51.33%,_#855BF200_57.98%,_#22206D20_62.05%)] dark:bg-[linear-gradient(0deg,_#1F0134_31.11%,_#4D27B600_51.33%,_#855BF200_57.98%,_#22206D_62.05%)] blur-[100px] dark:blur-[100px]"
        >
          <div
            class="w-[2260px] h-[1440px] bg-white dark:bg-[var(--color-5)] rounded-[100%] absolute top-[200px] left-0"
          ></div>
        </div>
        <NuxtImg
          v-if="$colorMode.preference != 'dark'"
          src="/images/cms-back-laravel.webp"
          class="absolute -top-96 left-1/2 -translate-x-1/2 min-w-[3745px] min-h-[2349]"
          width="3745"
          height="2349"
          alt="cms-back"
          loading="lazy"
          format="webp"
        />

        <div class="rising-stars top-0">
          <div style="height: 4px; width: 4px" q:key="0"></div>
          <div style="height: 2px; width: 2px" q:key="1"></div>
          <div style="height: 1px; width: 1px" q:key="2"></div>
        </div>

        <div
          class="max-w-screen-xl mx-auto px-4 w-full grid md:grid-cols-2 gap-6 relative z-10"
        >
          <div class="max-md:text-center mx-auto max-w-[504px]">
            <h3>
              <WrGradientText
                text="Get all your questions"
                append-class="py-0 md:py-4"
              />
              <span>answered here</span>
            </h3>
            <p class="mt-5 pr-4 text-lg tracking-[0.5px]">
              Here are some frequently asked questions about Nuxt.js and our
              process for Nuxt.js development.
            </p>
            <ul
              class="mt-8 list-disc max-md:gap-y-4 max-md:max-w-max max-md:mx-auto max-md:grid max-md:grid-cols-2 text-[var(--secondary-foreground)] md:space-y-4 list-inside text-left"
            >
              <li
                v-for="(item, index) in items"
                :key="index"
                @click="setActive(index)"
                :class="{
                  'cursor-pointer': true,
                  active: activeIndex === index,
                }"
              >
                {{ item }}
              </li>
            </ul>
            <WrButton
              container-class="mt-8 max-md:mx-auto"
              @click="handleButtonClick"
              >Connect with us</WrButton
            >
          </div>
          <div class="grow">
            <WrAccordion :Content="filteredAccordionContent" />
          </div>
        </div>
      </section>

      <section
        class="relative z-10 py-10 lg:pb-20 grid place-items-center order-7"
      >
        <div class="max-w-screen-lg mx-auto overflow-hidden px-4">
          <h2 class="text-center">
            <WrGradientText
              text="Accelerate Release"
              append-class="py-0 md:py-4"
            />
            <p class="">and Maintain Excellence</p>
          </h2>
          <p class="text-lg text-center mb-10 mt-4 tracking-[0.5px]">
            100% Risk-Free with a 1-Week Trial Period—Shortlist and Hire the
            Right Developer
          </p>
        </div>
        <div class="overflow-x-auto w-full px-4 no-scrollbar">
          <WrPricing
            :pricing-content="pricingContent"
            class="w-full"
            @openPopup="handleButtonClick"
          />
        </div>
        <WrButton container-class="mt-8 mx-auto" @click="handleButtonClick"
          >Schedule an Interview</WrButton
        >
      </section>

      <section
        class="relative z-20 py-10 lg:pb-40 overflow-hidden grid place-items-center order-8"
      >
        <div class="max-w-screen-xl mx-auto px-4 w-full">
          <h2 class="text-center">
            <WrGradientText
              text="Begin upgrading"
              append-class="py-0 md:py-4"
            />
            <p class="">your web application with us.</p>
          </h2>
          <p class="text-lg text-center mb-8 md:mb-20 mt-7 tracking-[0.5px]">
            Let us manage while you relax.
          </p>
          <WrTechUpgrade
            :pre-ver="preVer"
            :latest-ver="latestVer"
            :old-version="oldVersion"
            :new-version="newVersion"
          />
        </div>
      </section>

      <section
        class="relative z-10 section-spacing dark:bg-none overflow-visible order-9"
      >
        <div class="container-wrapper-lg w-full relative">
          <div
            class="hidden dark:block opacity-30 md:size-[764px] rounded-full bg-[linear-gradient(136.28deg,_rgba(51,4,79,0)_30.43%,_#260049_54.53%,_#36006F_92.37%)] absolute -top-[30%] -left-[67%]"
          ></div>

          <div
            class="hidden dark:block opacity-50 size-[190px] rounded-full bg-[image:var(--bg-circle-top-light)] absolute -bottom-[15%] right-0 top-0"
          ></div>
          <WrSelectedProject />
        </div>
      </section>
      <section
        class="relative z-10 py-10 lg:pb-32 overflow-hidden grid place-items-center order-10"
      >
        <div class="max-w-screen-xl mx-auto px-4 w-full">
          <h2 class="text-center">
            <WrGradientText text="Why outsource to India?" />
          </h2>
          <div class="grid md:grid-cols-2 gap-8 max-w-max mx-auto mt-10">
            <div v-for="reason in outsource" class="flex items-center gap-5">
              <div
                class="p-px bg-[#957EFF] dark:bg-transparent dark:bg-[image:var(--border-form-card)] rounded-full"
              >
                <div
                  class="size-16 md:size-24 rounded-full bg-white dark:bg-[#200945] grid place-items-center text-2xl"
                >
                  {{ reason.id }}.
                </div>
              </div>
              <p v-html="reason.text" class="text-base md:text-xl"></p>
            </div>
          </div>
        </div>
      </section>
    </div>

    <section
      class="relative py-10 lg:py-20 overflow-hidden max-w-screen-xl mx-auto px-4 z-20"
    >
      <h2 class="text-center">
        <WrGradientText text="Trusted for excellence and efficiency" />
      </h2>
      <p
        class="text-lg text-[var(--foreground)] mb-10 text-center tracking-[0.5px]"
      >
        Webreinvent is trusted by leading organisations to enhance their
        development and operational efficiency.
      </p>
      <!-- Carousel Section -->

      <WrTestimonialCardCarousel />

      <WrButton link="/testimonials" container-class="max-w-max mx-auto mt-2"
        >View All</WrButton
      >
    </section>
  </div>
  <WrContactFormPopup
    :isOpen="visible"
    @close="visible = false"
    class="z-30"
    :prefilledContent="formPrefilledData"
  />
</template>
